import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'components/Button';
import ContentBox from 'components/ContentBox';

export const StyledContentBox = styled(ContentBox)`
  margin: 8px auto !important;

  > div > div {
    display: flex;
    flex-flow: column nowrap;
  }
`;

export const HeadingLine = styled.div`
  font-size: 1.6rem;
`;

export const Reviewer = styled.div`
  display: flex;
  margin: 16px 0;
`;

export const ReviewerAvatarWrapper = styled.div`
  min-width: 90px;
  margin-right: 12px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReviewerLogo = styled.div`
  display: block;
  ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
`;

export const Grid = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Column = styled.div`
  width: 100%;
  margin-top: 10px;
`;

export const SectionTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-size: 1.2rem;
  font-weight: bold;
`;

export const CtaGrid = styled.div`
  justify-content: space-between;
  display: flex;
`;

export const CtaContainer = styled.div`
  margin-top: auto;
  ${({ theme }) => theme.breakpoints.sm} {
    margin: 0;
  }
`;

export const CaseStudyButton = styled(Button)`
  background: ${({ theme }) => theme.colors.primary.orange};
  color: ${({ theme }) => theme.colors.secondary.white};
  &:after {
    display: none;
  }
  &:before {
    display: none;
  }
  ${({ theme }) => theme.breakpoints.sm} {
    width: 100%;
  }
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 10px;
`;

export const Review = styled.div`
  font-style: italic;
`;

export const Solution = styled.div`
  margin: 5px 0 20px 0;
`;

export const Project = styled.div`
  margin: 5px 0 20px 0;
`;

export const DateWrapper = styled.div`
  margin: 10px 0;
`;
